import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Field from '../../../../../../components/Form/Field'
import ToggleField from '../../../../../../components/Form/ToggleField'

import { formatOptionsList } from '../../../../../../features/formatters'

import { accessibleSocialPagesSelector } from '../../../../../../modules/selectors/socialAccounts'

import { FB_PAGE_CHOICE, FB_SPONSOR_PAGE_ID, INCLUDE_PARTNERSHIP_PAGE } from '../../../fields'

const SocialAccountsFields = ({ formik, adValues, onUpdateFacebookPageHandler }) => {
  const { t } = useTranslation()

  const facebookPages = useSelector(accessibleSocialPagesSelector)

  const { values, setFieldValue } = formik

  const includePartnershipPage = values[INCLUDE_PARTNERSHIP_PAGE]

  const initialSponsorPageId = adValues[FB_SPONSOR_PAGE_ID]

  const formattedFacebookPages = formatOptionsList({
    list: facebookPages,
    valueName: 'external_id',
    labelName: 'name'
  })

  useEffect(() => {
    if (!includePartnershipPage) {
      // Reset sponsorPageId when turn off partnership toggle
      setFieldValue(FB_SPONSOR_PAGE_ID, '')
    }
  }, [includePartnershipPage, setFieldValue])

  return (
    <>
      <Field
        placeholder={t('Facebook page')}
        formik={formik}
        name={FB_PAGE_CHOICE}
        options={formattedFacebookPages}
        isLoading={false}
        isMulti={false}
        isSearchable={false}
        onValueChange={onUpdateFacebookPageHandler}
      />
      <br />
      {/*Show Partnership ads toggle only if sponsor page initially exists*/}
      {initialSponsorPageId && (
        <ToggleField
          name={INCLUDE_PARTNERSHIP_PAGE}
          setFieldValue={setFieldValue}
          isEnabled={includePartnershipPage}
          label="Partnership ad"
        />
      )}
      {includePartnershipPage && (
        <Field
          placeholder={t('Sponsor facebook page')}
          formik={formik}
          name={FB_SPONSOR_PAGE_ID}
          options={formattedFacebookPages}
          isLoading={false}
          isMulti={false}
          isSearchable={false}
        />
      )}
    </>
  )
}

export default SocialAccountsFields
